import {Deserializable} from './deserializable';
import {AccessMethod} from './accessMethod';


export class AccessMethods implements Deserializable {
  methods: AccessMethod[];

  deserialize(input: any) {

    Object.assign(this, input);
    if (!input) {
      return this;
    }

    return this;
  }
}
